export type FaqBlock =
  | { kind: 'text'; text: string }
  | { kind: 'list'; items: string[] }
  | { kind: 'steps'; items: string[] }

export interface FaqItem {
  id: string
  question: string
  blocks: FaqBlock[]
}

export const faqItems: FaqItem[] = [
  {
    id: 'faq-1',
    question: '¿Necesito tener un dron antes de comprar?',
    blocks: [
      {
        kind: 'text',
        text: 'No, y recomendamos que NO compres uno hasta leer los Tomos 1 y 3. Ahí aprendes qué tipo de dron necesitas según tu meta y tu presupuesto real, para no gastar USD 500–2,000 en el equipo equivocado.',
      },
    ],
  },
  {
    id: 'faq-2',
    question: '¿Este material me certifica?',
    blocks: [
      {
        kind: 'text',
        text: 'Honestamente, no: te prepara para certificarte. La licencia la otorga la autoridad de tu país. El camino típico es:',
      },
      {
        kind: 'steps',
        items: [
          'Lees Drone Commander (4–6 semanas)',
          'Curso en una escuela autorizada (30–40 horas)',
          'Examen teórico y práctico',
          'Recibes tu licencia oficial',
        ],
      },
      {
        kind: 'text',
        text: 'El Tomo 4 es el simulacro completo de ese examen.',
      },
    ],
  },
  {
    id: 'faq-3',
    question: '¿Me sirve si vivo en otro país?',
    blocks: [
      {
        kind: 'text',
        text: 'Cubre en detalle Argentina, Colombia, México, Chile y Perú, con análisis país-específico en cada tomo. Si vives en otro país de LATAM, el 95% del contenido te sirve porque se basa en estándares OACI.',
      },
    ],
  },
  {
    id: 'faq-4',
    question: '¿Cuánto tiempo tarda leer todo?',
    blocks: [
      {
        kind: 'list',
        items: [
          'Ritmo rápido (3–4 h/día): 2–3 semanas',
          'Ritmo normal (1–2 h/día): 4–6 semanas',
          'Ritmo tranquilo (30 min/día): 3–4 meses',
        ],
      },
      { kind: 'text', text: 'No hay prisa: muchos leen un tomo por mes mientras aprenden a volar.' },
    ],
  },
  {
    id: 'faq-5',
    question: '¿Necesito conocimientos de ingeniería?',
    blocks: [
      {
        kind: 'text',
        text: 'Cero. Cada concepto se explica con analogías del mundo real: la sustentación es “por qué un avión vuela cuando va rápido”, el drag es “por qué el viento te frena”, la IMU es “cómo el dron sabe que está inclinado”.',
      },
    ],
  },
  {
    id: 'faq-6',
    question: '¿Cómo recibo el material?',
    blocks: [
      {
        kind: 'text',
        text: 'Al instante. Después de pagar en Hotmart recibes el email de confirmación en menos de 1 minuto y descargas los 7 PDF para leerlos offline en cualquier dispositivo. Sin envíos ni esperas.',
      },
    ],
  },
  {
    id: 'faq-7',
    question: '¿Qué pasa si cambian las leyes?',
    blocks: [
      {
        kind: 'text',
        text: 'La Edición 2026 cubre regulaciones verificadas hasta octubre de 2026. Si cambian las normas o los estándares OACI, recibes las versiones actualizadas gratis por email. Tu inversión vale mínimo 2 años.',
      },
    ],
  },
  {
    id: 'faq-8',
    question: '¿Hay soporte si no entiendo algo?',
    blocks: [
      {
        kind: 'text',
        text: 'Sí. Escríbenos a soporte@dronecommander.lat y respondemos en menos de 24 horas cualquier duda sobre el contenido.',
      },
    ],
  },
]
